<template>
  <div>
    <div class="main">
      <TitleSlot title="新品上市" :showMore="false"></TitleSlot>
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="(item,i) in shopList" :key="i" class="list">
          <div v-for="(shop,index) in item" :key="index" class="shop">
            <router-link :to="{name:'detail',params: {goodsId:shop.id}}">
              <div class="shop-img" v-show="shop.image_url">
                <img v-lazy="shop.image_url" :alt="shop.name" :key="shop.image_url">
              </div>
              <div class="name">{{shop.name}}</div>
              <!-- <div class="tags">
              <div v-for="(tip,i) in shop.tag" :key="i" class="tag">{{tip}}</div>
              </div>-->
              <div class="price">{{shop.price}}元</div>
            </router-link>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import TitleSlot from "./TitleSlot.vue";
import chunk from "lodash.chunk";
export default {
  name: "NewShopList",
  components: {
    TitleSlot
  },
  props: {
    newsList: {
      type: [Object, Array],
      default: function() {
        return [];
      }
    }
  },
  computed: {
    shopList() {
      return chunk(this.newsList, 5);
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    console.log("shopList",this.shopList);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";
.main {
  margin-bottom: 50px;
  .list {
    height: 300px;
    overflow: hidden;
    .shop {
      float: left;
      width: 231px;
      height: 300px;
      background: rgba(255, 255, 255, 1);
      margin-right: 17px;
      cursor: pointer;
      position: relative;
      a {
        display: block;
      }
      &:last-of-type {
        margin-right: 0;
      }
      .shop-img {
        width: 170px;
        height: 170px;
        margin: 20px auto 0;
        // padding: 20px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .name {
        width: 80%;
        font-size: 13px;
        line-height: 22px;
        font-weight: 400;
        text-align: left;
        margin: 20px auto;
        color:#666;
        @include no-wrap-line(2);
        height: 40px;
      }
      .tags {
        display: flex;
        justify-content: center;
        .tag {
          height: 18px;
          line-height: 18px;
          padding: 0 8px;
          background-color: #83c44e;
          font-size: 10px;
          font-weight: 400;
          color: #fff;
          margin: 5px 4px;
          text-align: center;
        }
      }
      .price {
        height: 16px;
        font-size: 14px;
        color: $price;
        text-align: center;
        padding: 10px 0;
        position: absolute;
        bottom: 10px;
        left: 0;
        width: 100%;
      }
    }
  }
}
</style>

